import { defineStore } from 'pinia';
import mainAPI from "@/api/mainAPI";
import MyPlugin from "@/plugins/plugin";
import languages from '@/configs/language';
import config from '@/configs/config.js';
import { useGeneralStore } from '@/stores/GeneralStore'

export const useUserStore = defineStore("UserStore", {
    state: () => ({
        username: "", 
        name: "",
        fast_username: null,
        user_id: null,
        user_key: null,
        uuid: null,
        company_id: null,
        company_name: null,
        customer_id: null,
        access_token: "",
        selectedUserData: {},
    }),
    getters: {
        getUsername: (state) => state.username,
    },
    actions: {
        userLogout(){
            this.username = "";
            this.name = "";
            this.fast_username = "";
            this.user_id = null;
            this.user_key = null;
            this.company_id = null;
            this.company_name = null;
            this.uuid = null;
            this.customer_id = null;
            this.access_token = "";
        },
        async userLogin(user_id, password, ownerid) {
            let generalStore = useGeneralStore();
            let header = {}

            let params = {
                "user_id": user_id,
                "password": password,
                "owner_id": ownerid
            }

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "LOGINUSER",
                "user_id": user_id,
                "user_key": "",
                "timestamp": timestamp
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let data = res.data.data[0]

                this.user_id = data.user_id;
                this.user_key = data.user_key;
                this.uuid = data.uuid;
                this.company_id = data.company_id;
                this.company_name = data.company_name;
                this.customer_id = data.customer_id;
                this.fast_username = data.fast_username;
                console.log(this.fast_username)

                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getAccessToken() {
            let generalStore = useGeneralStore();
            let header = {}

            let params = {}

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETACCESSTOKEN",
                "user_id": this.user_id,
                "user_key": this.user_key,
                "timestamp": timestamp
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let data = res.data.data[0]
                
                this.access_token = data.access_token;

                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async updateUser(params) {
            let generalStore = useGeneralStore();
            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "UPDATEUSER",
                "user_id": this.user_id,
                "user_key": this.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, this.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async userChangePassword(old_password, new_password, ownerid) {
            let generalStore = useGeneralStore();
            let params = {
                "user_id": this.user_id,
                "old_password": old_password,
                "new_password": new_password,
                "owner_id": ownerid
            }

            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "CHANGEPASSWORDUSER",
                "user_id": this.user_id,
                "user_key": this.user_key,
                "timestamp": timestamp
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, this.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success" }
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },

        async getUser(params) {
            let generalStore = useGeneralStore();
            let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

            let apiData = {
                "apirequest": "GETUSER",
                "user_id": this.user_id,
                "user_key": this.user_key,
                "timestamp": timestamp,
            }

            let body = {
                apidata: apiData,
                params: params
            }

            let signature = MyPlugin.generateSignature(body, this.user_key, timestamp);

            let header = {
                "X-Signature": signature
            }

            let res = await mainAPI.requestHandler(header, body);
            
            if (res && res.status && res.status == 200 && res.data.status == "ok") {
                let resp = { status: "ok", message: "Success", data: res.data.data}
                return resp;
            } else {
                let resp = { status: "not-ok", message: `${languages[generalStore.$state.choosedLanguage]["err_msg_500"]}.` }
                if(res && res.status && res.status == 400 && res.data && res.data.msg) {
                    resp.message = res.data.msg
                }
                
                return resp;
            }
        },
    },
    persist: {
        key: config.activeOwner == 1 ? `userStore_${config.owner[0].localStorageKey}` : `userStore_${config.owner[1].localStorageKey}`,
        paths: ['username', 'name', 'fast_username', 'user_id', 'user_key', 'uuid', 'company_id', 'company_name', 'customer_id', 'access_token'],
    },
})